"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPathGroup = exports.apiPathGroup = exports.packageGroup = exports.subjectName = void 0;
exports.subjectName = 'OAuth Client';
exports.packageGroup = 'oauth-client';
exports.apiPathGroup = 'oauth-clients';
exports.routerPathGroup = 'oauth-client';
